<form [formGroup]="checklistForm" (ngSubmit)="submitForm()" class="checklist-form-container">
    <div class="disable-layer" *ngIf="!!disableForm"></div>
    <div class="field-container">
        <div class="action-buttons">
            <button class="cancel-btn" type="button" (click)="cancelForm()">
                <span>{{ 'generalSettings.cancel' | translate }}</span>
            </button>

            <button type="submit" class="save-btn"
                [ngClass]="(checklistForm.valid && (isChildChecklistEnabled.value ? childChecklistArray?.value.length : true)) ? 'enabled' : ''">
                <span>{{ 'generalSettings.saveChanges' | translate }}</span>
            </button>
        </div>
    </div>
    <div class="form-title">{{ 'checklist.selectedChecklistDetails' | translate }}</div>
    <div class="checklist-form">
        <div class="checklist-title">
            <div class="title-left" [ngClass]="!isEnglishText ? 'custom-width' : ''">
                <div class="checklist-name">{{checklistForm.get('displayName').value}} <span
                        *ngIf="checklistForm.get('status').value"
                        title="{{ 'checklist.checklistItemIsOnline' | translate }}" class="status"></span>
                </div>
                <div class="checklist-category">{{getCategoryTranslation(checklistForm.get('category').value) | translate}}</div>
            </div>

            <div class="title-right">
                <div class="text">{{ 'opcodeServiceManagement.status' | translate }}</div>
                <div class="switch" [ngClass]="isMandatory.value || isAutoSelect.value ? 'readonly-layer' : ''">
                    <app-onofswitch [switchInput]="checklistForm.get('status').value"
                        (switchChange)="updateSwitchValues($event, 'status')">
                    </app-onofswitch>
                </div>
            </div>
        </div>
        <div class="toggles" [ngClass]="!isEnglishText ? 'custom-style' : ''">
            <div class="mandatory" title="Mandatory for delivery appointments only">
                <div class="text">{{ 'checklist.mandatory' | translate}}</div>
                <div class="switch" [ngClass]="isCorporateMandatory.value ? 'readonly-layer' : ''">
                    <app-onofswitch [switchInput]="checklistForm.get('isMandatory').value"
                        (switchChange)="updateSwitchValues($event, 'isMandatory')">
                    </app-onofswitch>
                </div>
            </div>
            <div class="auto-select">
                <div class="text">{{ 'checklist.autoSelect' | translate}}</div>
                <div class="switch" [ngClass]="isMandatory.value ? 'readonly-layer' : ''">
                    <app-onofswitch [switchInput]="checklistForm.get('autoSelect').value"
                        (switchChange)="updateSwitchValues($event, 'autoSelect')">
                    </app-onofswitch>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-md-12">
                <div class="field-left-col">
                    <label>{{ 'opcodeServiceManagement.displayName' | translate }}<span
                            style="color:red">*</span></label>
                    <mat-form-field appearance="outline">
                        <input matInput formControlName="displayName" type="text" autocomplete="off" maxlength="250">
                        <mat-error *ngIf="hasError('displayName','required')">{{
                            'opcodeServiceManagement.displaynameIsRequired' | translate }}</mat-error>
                    </mat-form-field>
                </div>
                <div class="field-right-col">
                    <label>{{ 'checklist.category' | translate }}<span style="color:red">*</span></label>
                    <mat-form-field appearance="outline">
                        <mat-select formControlName="category" placeholder="{{ 'checklist.selectCategory' | translate }}">
                            <mat-option [value]="''">{{ 'checklist.selectCategory' | translate }}</mat-option>
                            <mat-option [value]='obj.id' *ngFor="let obj of categories">
                                {{ obj.display | translate}}
                            </mat-option>
                        </mat-select>
                        <mat-error *ngIf="checklistForm.get('category').invalid">{{ 'checklist.categoryIsRequired' | translate }}</mat-error>
                    </mat-form-field>
                </div>
            </div>
        </div>

        <div class="field-container" style="margin-bottom: -1rem">
            <div class="field-left">
                <label class="font-weight-bold">{{ 'opcodeServiceManagement.detailedDescription' | translate }}</label>
                <mat-form-field class="no-fixed-height" appearance="outline">
                    <textarea matInput formControlName="description"
                        placeholder="{{ 'opcodeServiceManagement.enterDetailedDescription' | translate }}"
                        maxlength="1000"></textarea>
                </mat-form-field>
            </div>
            <div class="field-center">
                <label class="font-weight-bold">
                    {{ 'checklist.duration(Min)' | translate }}
                    <span style="color:red">*</span></label>
                <mat-form-field appearance="outline">
                    <input matInput formControlName="duration" type="number"
                        placeholder="{{ 'opcodeServiceManagement.enterDuration' | translate }}"
                        [readonly]="isChildChecklistEnabled.value" min="0">
                    <mat-error *ngIf="hasError('duration','required')">{{ 'opcodeServiceManagement.durationIsRequired' |
                        translate }}</mat-error>
                    <mat-error *ngIf="hasError('duration' ,'min')">
                        {{'generalSettings.pleaseEnterValue' |translate }} <strong>{{'generalSettings.greaterThan0'
                            |translate }}</strong>
                    </mat-error>
                    <mat-error *ngIf="hasError('duration' ,'Min10')">
                        {{'checklist.theDurationOfThisItemCanNotBeBelow10mins' |translate }} 
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="field-right mt-4">
                <mat-checkbox formControlName="userComments">
                    <span>{{ 'opcodeServiceManagement.userComments' | translate }}</span>
                </mat-checkbox>
                <mat-checkbox formControlName="commentsRequired" [disabled]="!commentsEnabledField.value">
                    <span>{{ 'opcodeServiceManagement.commentsRequired' | translate }}</span>
                </mat-checkbox>
            </div>
        </div>

        <app-splitter class="app-splitter mx-3" [config]="'horizontal 100% 0 0.5rem'"></app-splitter>

        <div>
            <mat-checkbox formControlName="isChildChecklistEnabled" (change)="onChildChecklistChecked()"
             [disabled]="isCorporateMandatory.value && isChildChecklistEnabled.value && hasDefaultSubItem()">
                <span class="primary-text-color">{{ 'checklist.subChecklistItems' | translate }}</span>
            </mat-checkbox>
        </div>

        <div [ngClass]="isChildChecklistEnabled.value ? '' : 'disable-section'">

            <div class="field-container" *ngIf="childChecklistArray?.controls?.length">

                <table formArrayName="childChecklist" aria-describedby="">
                    <thead>
                        <th scope="col" style="width: 33%">{{'servicePersonnel.name' | translate}}<span style="color:red">*</span></th>
                        <th scope="col" style="width: 22%">{{ 'checklist.duration(Min)' | translate}}<span style="color:red">*</span></th>
                        <th scope="col" style="width: 10%">{{'servicePersonnel.online' | translate}}</th>
                        <th scope="col" style="width: 15%">{{ 'checklist.autoSelect' | translate}}</th>
                        <th scope="col" style="width: 10%">{{'servicePersonnel.delete' | translate}}</th>
                    </thead>
                    <tr *ngFor="let item of  childChecklistArray?.controls, let i = index" [formGroupName]="i">
                        <td>
                            <mat-form-field appearance="outline">
                                <input matInput formControlName="name" type="text" placeholder="Enter Name">
                                <mat-error>{{ 'checklist.nameIsRequired' | translate}}</mat-error>
                            </mat-form-field>
                        </td>
                        <td>
                            <mat-form-field appearance="outline">
                                <input matInput formControlName="duration" type="number"
                                    placeholder="{{ 'opcodeServiceManagement.enterDuration' | translate }}" min="0">
                                <mat-error>
                                    {{ 'checklist.enterValueGreaterThan0' | translate}}
                                </mat-error>
                            </mat-form-field>
                        </td>
                        <td>
                            <mat-checkbox #online formControlName="online" [disabled]="autoSelect.checked || (online.checked && isMandatory.value)"
                            (change)="onSubItemOnlineChange(online.checked, i)">
                            </mat-checkbox>
                        </td>
                        <td>
                            <mat-checkbox #autoSelect formControlName="autoSelect" [disabled]="autoSelect.checked && isMandatory.value" (change)="onSubItemAutoSelectChange(autoSelect.checked, i)">
                            </mat-checkbox>
                        </td>
                        <td>
                            <div style="cursor: pointer" [ngClass]="item.value.isDefault ? 'readonly-layer' : ''">
                                <asp-icon class='app-icon' height='1rem' width='1rem'
                                    name='ic-20-utility-delete-trash.svg' color='rgba(14,19,25,0.8)'
                                    (click)="onDeleteChildItem(i)">
                                </asp-icon>
                            </div>
                        </td>
                    </tr>
                </table>

            </div>

            <div class="addon-checklist">
                <div class="half-width">
                    <form>
                        <label>{{ 'checklist.addChecklistItem' | translate}}<span style="color:red"
                                *ngIf="!childChecklistArray.value.length">*</span></label>
                        <mat-form-field appearance="outline">
                            <input type="text" autocomplete="off" placeholder="{{ 'checklist.typeTheChecklistItemYouWishToAdd' | translate}}"
                                matInput [formControl]="addonChecklist">
                        </mat-form-field>
                    </form>
                </div>

                <div (click)="onAddChecklist()" class="d-flex font-weight-bold primary-text-color half-width"
                    style="margin-top: 3rem;" [ngClass]="addonChecklist.value ? '': 'disable-section'">
                    <mat-icon class="add-new">add</mat-icon>
                    <span style="padding-left:2%; cursor: pointer;">{{ 'departmentHolidays.addnew' | translate}}</span>
                </div>
            </div>
        </div>

    </div>
</form>